'use strict';

if (typeof window !== 'undefined' && !window.location.origin) {
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/origin.polyfill.js
// module id = 370
// module chunks = 0